var map = {
	"./kf-confirm.tag": 16,
	"./kf-dialog.tag": 17,
	"./kf-img.tag": 18,
	"./kf-loader.tag": 19,
	"./kf-modal.tag": 20,
	"./kf-payjp.tag": 21,
	"./kf-raw.tag": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;